import { Signal } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';
import { TellentNavigationItem } from '@core/tellent-types';

import { TellentNavigationController } from './navigation.controller';

export const { provide: provideTellentNavigationItems, inject: injectTellentNavigationItems } =
  createProviderToken<Signal<TellentNavigationItem[]>>('TellentNavigationItems')();

export const {
  provide: provideTellentNavigationController,
  inject: injectTellentNavigationController,
} = createProviderToken<TellentNavigationController>('TellentNavigationController')();

export const {
  provide: provideTellentIsOneSettingsEnabled,
  inject: injectTellentIsOneSettingsEnabled,
} = createProviderToken<boolean>('TellentOneSettingsEnabled')();
